import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

export function formatCountries(
  countries:
    | ApiSpecs['/bm/cart']['GET']['response']['shippableCountries']
    | ApiSpecs['/bm/cart']['GET']['response']['billableCountries'],
) {
  return [...countries]
    .map(({ name, countryCode: code }) => ({
      value: code,
      label: name,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}
